import { XIcon } from 'lucide-react-native';
import { Stack, type StackProps, styled } from 'tamagui';

import { Icon } from '../icons/Icon';

const BaseButton = styled(Stack, {
    alignSelf: 'flex-start',
    backgroundColor: '$white',
    padding: 8,
    borderRadius: 16,
    cursor: 'pointer',
    animation: 'button',
    pressStyle: { scale: 0.95 },
});

interface CloseButtonProps extends StackProps {
    background?: 'transparent' | 'gray';
}

export const CloseButton = ({
    background = 'transparent',
    ...props
}: CloseButtonProps) => {
    const backgroundProps =
        background === 'gray'
            ? { backgroundColor: '$gray200' }
            : { backgroundColor: 'transparent' };

    return (
        <BaseButton {...props} {...backgroundProps}>
            <Icon icon={XIcon} size={24} color="$black" />
        </BaseButton>
    );
};
